import React from 'react';
import useMultiLanguageContext from '../../MultiLanguageContext/useMultiLanguageContext';
import useSessionInfoContext from '../SessionInfoContextProvider/useSessionInfoContext';
import { SessionLanguageContext } from './useSessionLanguageContext';

export default function SessionLanguageContextProvider({ children }: { children: React.ReactNode }) {
  const { session } = useSessionInfoContext();
  const { language } = useMultiLanguageContext();

  const value = React.useMemo(() => {
    if (language) {
      const sessionTranslation = session?.project.translations?.find((t) => t.language === language);
      if (sessionTranslation) {
        return { sessionLanguage: sessionTranslation.language };
      }
    }
    return { sessionLanguage: session?.project.asrLanguage };
  }, [language, session?.project]);

  return (
    <SessionLanguageContext.Provider value={value}>
      {children}
    </SessionLanguageContext.Provider>
  );
}
